<nav
  class="wo-page-mobile-tab-bar-nav"
  tuiTabBar
  ngProjectAs="tuiOverContent"
>
  <wo-page-mobile-nav-tab-bar-item
    tuiTabBarItem
    [title]="'page.order-list' | translate"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: false }"
    [routerLink]="['/', AppRoutingPaths.ORDERS]"
    iconName="clipboard-list" data-e2e="order list button"
  />
  <wo-page-mobile-nav-tab-bar-item
    tuiTabBarItem
    [title]="'Pending'"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    [routerLink]="['/', AppRoutingPaths.ORDERS, AppRoutingPaths.ORDERS_PENDING]"
    iconName="pending" data-e2e="order list button"
  />
  <wo-page-mobile-nav-tab-bar-item
    *ngIf="true | ifHasPermission:'can create a new order'"
    [title]="'page.new-order' | translate"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    [routerLink]="['/', AppRoutingPaths.NEW_ORDER]"
    [state]="{ shouldClearState: true }"
    iconName="add_order" data-e2e="new order button"
  />
  <wo-page-mobile-nav-tab-bar-item
    *ngIf="siteId$ | async as siteId"
    [title]="'Waste'"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: false }"
    [routerLink]="AppRoutingLinks.site(siteId)"
    iconName="waste" data-e2e="waste button"
  />
  <wo-page-mobile-nav-tab-bar-item
    *ngIf="canSeeSwitchContext$ | async"
    [title]="'Location'"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    [routerLink]="['/', AppRoutingPaths.APP_CONTEXT]"
    [state]="{ shouldClearState: true }"
    iconName="pin" data-e2e="location button"
  />
</nav>
